// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1985":"23a88b60","2969":"c7110c99","4255":"f16783e3","5229":"060ceb5b","6113":"f3919cc6","9722":"e2b4a2f9"}[chunkId] + ".css";
};